import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { getData } from 'src/services/RestApi';
import SearchSelectField from 'src/components/widgets/search-select-field';
import {
  setCacheDegree,
  getCacheDegree,
} from 'src/utils/cache-data';

export const DropdownDegree = forwardRef(({
  formik,
  disabled = false,
  type = '2',
  label = 'Hạng',
  name,
  hintValue,
  onSelected,
  triggerReset,
  filterValues = [],
  ...otherProps
}, ref) => {
  const [data, setData] = useState([]);
  const [defaultVal, setDefaultVal] = useState(null);
  const isFetchingData = useRef(false);

  const selectRef = useRef(null);
  useImperativeHandle(ref, () => ({
    reset: () => {
      selectRef.current?.reset?.();
      setDefaultVal(null);
    }
  }));

  const bindToView = (result) => {
    let data = result[type];
    
    if(data){
      if (Array.isArray(filterValues) && filterValues.length > 0) {
        const filter = filterValues.map(String);
        data = data.filter(item => filter.includes(item.value));
      }
      setData(data);
    }
  };
  
  const fetchData = useCallback(async () => {
    if (!isFetchingData.current) {
      isFetchingData.current = true;
      try {
        const { result } = await getData('fixed/degree/cache');
        if (result) {
          bindToView(result);
          setCacheDegree(result);
        }
      } catch (error) {
        console.error('Failed to fetch group data:', error);
      } finally {
        isFetchingData.current = false;
      }
    }
  }, [type]);

  useEffect(() => {
    const savedData = getCacheDegree();
    if (savedData) bindToView(savedData);
    else fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (triggerReset) {
      const reloadValue = () => {
        setDefaultVal(null); // Reset the default value
      };
      // Pass the reloadValue function as a reference
      triggerReset(reloadValue); // Pass the function itself, not the result of its execution
    }
  }, [triggerReset]);

  
  const handleChanged = (selectedOption) => {
    if (onSelected) onSelected(selectedOption);
  };

  return (
    <SearchSelectField
      ref={selectRef}
      formik={formik}
      label={label}
      name={name}
      disabled={disabled}
      options={data}
      onSelected={handleChanged}
      defaultValue={defaultVal} // {label: '<name>', value: '<id>'}
      hintValue={hintValue || ''} // '<name>'
    />
  );
});

DropdownDegree.propTypes = {
  name: PropTypes.string.isRequired,
  onSelected: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  hintValue: PropTypes.string,
  triggerReset: PropTypes.func, // Function to handle auto reset
};

export default DropdownDegree;
